import { Extensions } from '@tiptap/react';
import Collaboration from '@tiptap/extension-collaboration';
import { Snapshot } from '@tiptap-pro/extension-snapshot';
import { TiptapCollabProvider } from '@tiptap-pro/provider';
import * as Y from 'yjs';

import { SnapshotState } from 'Tiptap/stores/EditorStore';

export interface CollaborationExtensionsOptions {
  provider: TiptapCollabProvider;
  ydoc: Y.Doc;
  onSnapshotUpdate?: (state: SnapshotState) => void;
}

export function createCollaborationExtensions(options: CollaborationExtensionsOptions): Extensions {
  const { provider, ydoc, onSnapshotUpdate } = options;

  return [
    Snapshot.configure({
      provider,
      onUpdate(payload) {
        onSnapshotUpdate?.({
          versions: payload.versions,
          currentVersion: payload.currentVersion,
          latestVersion: payload.version,
          autoVersioning: payload.versioningEnabled,
        });
      },
    }),
    Collaboration.configure({
      document: ydoc,
    }),
  ];
}
